import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { create } from 'ionicons/icons'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { saveTempSignature, getSignatures } from '../store/signatures.actions'

const AddSignatureButton: React.FC = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onAddSignatureClick = () => {
    dispatch(saveTempSignature(''))
    dispatch(getSignatures())
    history.push(AppRouterConstants.SIGNATURE_ROUTE)
  }

  return (
    <IonButton
      data-testid='AddSignatureButton'
      className='add-signature-button'
      expand='block'
      fill='clear'
      onClick={onAddSignatureClick}
      color='primary-alt'>
      <IonIcon icon={create} size='large' />
      {t('signature.addSignature')}
    </IonButton>
  )
}

export default AddSignatureButton
